import { forwardRef, type ReactNode } from 'react';
import {
  Button as StyledButton,
  type ButtonStyledProps,
} from './styled/button';
import { Spinner } from './spinner';
import {
  BIEvents,
  type BIEventProps,
  serializeBIEventData,
} from '@terra/ui-telemetry/bi-analytics';

export type { ButtonSize } from './styled/button';

export type ButtonProps = ButtonStyledProps & {
  loading?: boolean;
  loadingText?: ReactNode;
  bi?: BIEventProps;
};

export const Button = forwardRef<HTMLButtonElement, ButtonProps>(
  (props, ref) => {
    const { loading, disabled, loadingText, children, bi, ...rest } = props;

    const { eventType = BIEvents.CLICK, eventData } = bi ?? {};

    return (
      <StyledButton
        disabled={Boolean(loading || disabled)}
        data-loading={loading ? '' : undefined}
        ref={ref}
        data-bi-unmask="true"
        data-analytics-type={eventType}
        data-analytics-props={serializeBIEventData(eventData)}
        {...rest}
      >
        {loading ? (
          <>
            <ButtonSpinner />
            {loadingText ?? children}
          </>
        ) : (
          children
        )}
      </StyledButton>
    );
  },
);

Button.displayName = 'Button';

const ButtonSpinner = () => (
  <Spinner
    data-part="spinner"
    flexShrink={0}
    borderWidth="1.5px"
    borderTopColor="currentColor"
    borderRightColor="currentColor"
    borderBottomColor="transparent"
    borderLeftColor="transparent"
    color="currentColor"
  />
);
